import init from '../../helpers/init';
import {showAlert} from '../main';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  $(document).on('click', '.js-days .js-link', (e) => {
    e.preventDefault();
    const value = $(e.target).data('value');
    const name = $(e.target).data('name');
    if (name !== 'constant') {
      $('.js-pjax-input[name=constant]').val('');
    } else {
      $('.js-pjax-input[name=date]').val('');
    }
    $('.js-pjax-input[name=' + name + ']').val(value);
    $('form.js-calendar-filter').trigger('submit');
  });

  $(document).on('change', '.top-filter-calendar .js-select', (e) => {
    const value = $(e.target).select2({theme: 'classic'}).val();
    const name = $(e.target).data('name');
    $('input[name=' + name + ']').val(value);
    $('form.js-calendar-filter').trigger('submit');
  });

  $(document).on('click', '.js-del-event', (e) => {
    e.preventDefault();
    let url = e.currentTarget.getAttribute('href');
    let id = e.currentTarget.dataset.id;

    if (url !== null && url !== '') {
      $.ajax({
        method: 'GET',
        url: url,
        dataType: 'json'
      }).done(function (data) {
        if (data) {
          jQuery('[data-block=' + id + ']').remove();
        } else {
          showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Error!' : 'Ошибка!')
        }
      }).fail(function () {
        showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса!');
      });
    }
  });

  $(document).on('click', '.js-agree-event', (e) => {
    e.preventDefault();
    let url = e.currentTarget.getAttribute('href');
    let id = e.currentTarget.dataset.id;

    if (url !== null && url !== '') {
      $.ajax({
        method: 'GET',
        url: url,
        dataType: 'json'
      }).done(function (data) {
        console.log(data);
        if (data) {
          jQuery('[data-agree=' + id + ']').remove();
        } else {
          showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Error!' : 'Ошибка!')
        }
      }).fail(function () {
        showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса!');
      });
    }
  });

  $(document).on('submit', '#js-create-meeting', e => {
    e.preventDefault();

    const form = $(e.currentTarget);
    const meet: any = form.serializeArray().reduce(function (accum: any, current) {
      if (current.name === 'times' || current.name === 'online-times') {
        if (!accum['times']) {
          accum['times'] = [];
        }
        accum['times'].push(current.value);
      } else {
        accum[current.name] = current.value;
      }
      return accum;
    }, {});

    let action: String;
    // @ts-ignore
    if (parseInt(form.find('[name=id]').val(), 10) > 0) {
      action = 'update';
    } else {
      action = 'create';
    }

    const exhibitionXml = form.find('[name=exhibitionXml]').val();

    const errorBox = $('.js-error');
    errorBox.hide();
    BX.ajax.runComponentAction('pwd:calendar.create_meeting', action, {
      mode: 'class',
      data: {
        meet,
        exhibitionXml
      },
    }).then((result: any) => {
      console.log(result);
      if (result.data) {
        showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Meet was created' : 'Приглашение на встречу создано');
        if(action === 'update'){
          location.href = BX.message('LANGUAGE_ID') === 'en' ? '/eng' : '' + '/calendar/';
        }else{
          window.location.reload();
        }
      }
    })
      .catch((err: any) => {
        let errorText = <any>[];
        $.each(err.errors, function(i, v){
          if(v.message.indexOf('[Exception]') < 0){
            errorText.push(v.message);
          }
        });
        errorBox.html(errorText.join('<br>'));
        errorBox.show();
      });
  });

  $(document).on('change', '#js-create-meeting :checkbox', e => {
    const i = $(e.currentTarget).data('i');
    const day = $(e.currentTarget).data('day');
    const slotkey = $(e.currentTarget).data('slotkey');
    const key = $(e.currentTarget).data('key');

    if ($(e.currentTarget).is(':checked')) {
      if (!$('[data-day=' + day + '][data-key=' + (key + 1) + ']').is(':checked')
        && !$('[data-day=' + day + '][data-key=' + (key - 1) + ']').is(':checked')
        && $('[data-day=' + day + ']:not([data-key=' + (key) + '])').is(':checked')) {
        $(e.currentTarget).prop('checked', false);
      }
      if ($('[name=' + 'times' + ']:not([data-day=' + (day) + '])').is(':checked')) {
        $(e.currentTarget).prop('checked', false);
      }
      if ($('[name=' + 'online-times' + ']:not([data-day=' + (day) + '])').is(':checked')) {
        $(e.currentTarget).prop('checked', false);
      }
    } else {
      if ($('[name=' + 'times' + '][data-day=' + (day) + ']').is(':checked')
        && $('[data-day=' + day + '][data-key=' + (key + 1) + ']').is(':checked')
        && $('[data-day=' + day + '][data-key=' + (key - 1) + ']').is(':checked')) {
        $(e.currentTarget).prop('checked', true);
      }
      if ($('[name=' + 'online-times' + '][data-day=' + (day) + ']').is(':checked')
        && $('[data-day=' + day + '][data-key=' + (key + 1) + ']').is(':checked')
        && $('[data-day=' + day + '][data-key=' + (key - 1) + ']').is(':checked')) {
        $(e.currentTarget).prop('checked', true);
      }
    }
  });

  const parent = $('[name=number_stand]').parent();
  if ($('[name=online]').val() === 'off') {
    parent.show();
  } else {
    parent.hide();
  }

  $(document).on('change', '#js-create-meeting [name=online]', e => {
    const jsSelectTimeBox = $('.js-select-time-box');
    $('[name=times]').prop('checked', false);
    $('[name=online-times]').prop('checked', false);
    jsSelectTimeBox.find('.time-box').html('');
    jsSelectTimeBox.hide();

    if ($(e.currentTarget).val() === 'off') {
      parent.show();
    } else {
      parent.hide();
    }
  });

  const modalName = '#select-time';
  const onlineModalName = '#select-online-time';
  const modal = jQuery(modalName);
  const close = modal.find('.close');

  $(document).on('click', '.js-select-time', (e: JQuery.ClickEvent) => {
    e.preventDefault();
    if ($('#js-create-meeting [name=online]').val() === 'off') {
      modal.modal('show');
    } else {
      jQuery(onlineModalName).modal('show');
    }
  });

  let buttonClick = false;
  $(document).on('click', '.close', (e: JQuery.ClickEvent) => {
    e.preventDefault();
    modal.modal('hide');
    jQuery(onlineModalName).modal('hide');
    buttonClick = true;
  });

  $(onlineModalName).on('hidden.bs.modal', function (e) {
    const jsSelectTimeBox = $('.js-select-time-box');
    if (buttonClick) {
      let times = '';
      let selectTimeBox = false;
      $('[name=online-times]:checked').each(function (index) {
        selectTimeBox = true;
        times += '<div>' + $(this).data('time') + '</div>';
      });
      if (selectTimeBox) {
        jsSelectTimeBox.find('.time-box').html(times);
        jsSelectTimeBox.show();
      } else {
        jsSelectTimeBox.find('.time-box').html('');
        jsSelectTimeBox.hide();
      }
    } else {
      $('[name=times]').prop('checked', false);
      $('[name=online-times]').prop('checked', false);
      jsSelectTimeBox.find('.time-box').html('');
      jsSelectTimeBox.hide();
    }
    buttonClick = false;
  });

  $(modalName).on('hidden.bs.modal', function (e) {
    const jsSelectTimeBox = $('.js-select-time-box');
    if (buttonClick) {
      let times = '';
      let selectTimeBox = false;
      $('[name=times]:checked').each(function (index) {
        selectTimeBox = true;
        times += '<div>' + $(this).data('time') + '</div>';
      });

      if (selectTimeBox) {
        jsSelectTimeBox.find('.time-box').html(times);
        jsSelectTimeBox.show();
      } else {
        jsSelectTimeBox.find('.time-box').html('');
        jsSelectTimeBox.hide();
      }
    } else {
      $('[name=times]').prop('checked', false);
      $('[name=online-times]').prop('checked', false);
      jsSelectTimeBox.find('.time-box').html('');
      jsSelectTimeBox.hide();
    }
    buttonClick = false;
  });

  $(document).on('pjax:complete', function (xhr, textStatus, options) {
    const filter = $('.top-filter-calendar .filter-view, .top-filter-calendar .filter-status-meet');
    var CalendarComponent = BX.namespace('__pwd.CalendarComponent');
    if (CalendarComponent.constant === 1) {
      filter.hide();
    } else {
      filter.show();
    }
  });

  $(document).on('click', '.js-add-event', (e) => {
    e.preventDefault();
    let icon = $(e.currentTarget);
    let url = e.currentTarget.getAttribute('href');

    if (url !== null && url !== '') {
      $.ajax({
        method: 'GET',
        url: url,
        dataType: 'json'
      }).done(function (result) {
        if (result.data.add) {
          icon.addClass('active');
          icon.attr('href', '#');
          if(jQuery('.js-pjax-filter').length) {
            jQuery('.js-pjax-filter').submit();
          }
        } else if (result.data.double) {
          showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'The event is already in the calendar' : 'Событие уже есть в календаре');
        } else {
          showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Error!' : 'Ошибка!')
        }
      }).fail(function () {
        showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса!');
      });
    }
  });

  $(document).on('click', '.js-calendar-export-ical', (e) => {
    e.preventDefault();
    const url = new URL(<any>window.location);
    let constant = url.searchParams.get('constant');
    let exhibitionXml = $(e.currentTarget).data('exhibition');

    const data = {
      'constant': constant,
      'exhibitionXml': exhibitionXml
    };

    BX.ajax.runComponentAction('pwd:calendar', 'exportIcal', {
      data,
      mode: 'class',
    }).then((result: any) => {
      console.log(result);
      if (result.data && result.data.success) {
        var link = document.createElement('a');
        link.setAttribute('href', result.data.path);
        link.setAttribute('download', 'calendar.ics');
        link.click();
        return false;
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });

  $(document).on('click', '.js-calendar-export-pdf', (e) => {
    e.preventDefault();
    const url = new URL(<any>window.location);
    let mode = url.searchParams.get('days');
    let constant = url.searchParams.get('constant');
    let dateFilter = url.searchParams.get('date');
    let exhibitionXml = $(e.currentTarget).data('exhibition');
    if(!dateFilter){
      dateFilter = '';
    }
    const data = {
      'mode': mode,
      'constant': constant,
      'date': dateFilter,
      'exhibitionXml': exhibitionXml
    };
    BX.ajax.runComponentAction('pwd:calendar', 'exportPdf', {
      data,
      mode: 'class'
    }).then((result: any) => {
      console.log(result);
      if (result.data && result.data.success) {
        var link = document.createElement('a');
        link.setAttribute('href', result.data.path);
        link.setAttribute('download', 'calendar.pdf');
        link.click();
        return false;
      }
    }).catch((err: any) => {
      showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Request error!' : 'Ошибка запроса! Попробуйте позже.');
      console.log(err);
    });
  });
});
